import { render, staticRenderFns } from "./FooterBase.vue?vue&type=template&id=16437064&scoped=true&"
import script from "./FooterBase.vue?vue&type=script&lang=js&"
export * from "./FooterBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16437064",
  null
  
)

export default component.exports